const config = require('./config.js');

/**
 * @param {string} hex
 * @returns {?{red: number, green: number, blue: number}}
 */
function hexToRGB(hex) {
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

	hex = hex.replace(
		shorthandRegex,
		(match, red, green, blue) => red + red + green + green + blue + blue
	);

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

	return result
		? {
				red: parseInt(result[1], 16),
				green: parseInt(result[2], 16),
				blue: parseInt(result[3], 16),
		  }
		: null;
}

/**
 * @param {number} red
 * @param {number} green
 * @param {number} blue
 * @returns {number}
 */
function luminance(red, green, blue) {
	const luminanceValues = [red, green, blue].map((value) => {
		value /= 255;
		return value <= 0.03928
			? value / 12.92
			: Math.pow((value + 0.055) / 1.055, 2.4);
	});
	return (
		luminanceValues[0] * 0.2126 +
		luminanceValues[1] * 0.7152 +
		luminanceValues[2] * 0.0722
	);
}

/**
 * @param {string} hex
 * @returns {number}
 */
function getLuminanceFromHex(hex) {
	const rgbValues = hexToRGB(hex);

	if (!rgbValues) {
		return 0;
	}

	return luminance(rgbValues.red, rgbValues.green, rgbValues.blue);
}

/**
 * @param {string} foreground
 * @param {string} background
 * @returns {number}
 */
function contrastRatio(foreground, background) {
	const [foregroundLuminance, backgroundLuminance] = [
		foreground,
		background,
	].map(getLuminanceFromHex);

	return (
		(Math.min(foregroundLuminance, backgroundLuminance) + 0.05) /
		(Math.max(foregroundLuminance, backgroundLuminance) + 0.05)
	);
}

/**
 * TODO: Account for all color types
 * @param {string} foreground
 * @param {string} background
 * @param {'normal' | 'large'} threshold
 * @returns {boolean}
 */
function meetsContrastRequirement(
	foreground,
	background,
	threshold = 'normal'
) {
	return (
		contrastRatio(foreground, background) <
		(config[threshold] || config.normal)
	);
}

module.exports = {
	contrastRatio,
	hexToRGB,
	luminance,
	meetsContrastRequirement,
};
